// utils/myFunctions.js

export function scrollToSection(section) {
    console.log(section)
    const element = document.getElementById(section);

    element?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
}